import { useState } from 'react';
import PropTypes from 'prop-types';
import { apiFetch } from '../api';
import { Btn, Modal, Spinner } from './index';
import { AuthStatus, NewPasswordFields } from './AuthForm';
import PasswordInput from './PasswordInput';
import { passwordValidationError } from '../utils/passwordPolicy';

export default function ChangePasswordModal({ onClose, onChanged }) {
  const [current, setCurrent] = useState('');
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const submit = async (event) => {
    event.preventDefault();
    if (saving) return;
    const invalid = passwordValidationError(password);
    if (invalid) return setError(invalid);
    if (password !== confirmation) return setError('As senhas não coincidem.');
    setSaving(true); setError('');
    try {
      await apiFetch('/auth/change-password', { method: 'POST', body: JSON.stringify({ senha_atual: current, nova_senha: password }) });
      onChanged();
    } catch (err) { setError(err.message); setSaving(false); }
  };
  return <Modal title="Alterar minha senha" onClose={() => !saving && onClose()}>
    <form onSubmit={submit} style={{ display: 'grid', gap: 16 }}>
      <p style={{ color: 'var(--muted)', fontSize: '1rem' }}>Salve seu trabalho antes de continuar. Ao confirmar, suas sessões serão encerradas em todos os aparelhos.</p>
      <PasswordInput label="Senha atual" autoComplete="current-password" required value={current} onChange={e => setCurrent(e.target.value)} disabled={saving} />
      <NewPasswordFields password={password} confirmation={confirmation} onPassword={setPassword} onConfirmation={setConfirmation} disabled={saving} />
      <AuthStatus error={error} />
      <Btn type="submit" disabled={saving} style={{ justifyContent: 'center' }}>{saving ? <><Spinner /> Alterando...</> : 'Alterar senha e sair'}</Btn>
      <Btn variant="ghost" disabled={saving} onClick={onClose}>Cancelar</Btn>
    </form>
  </Modal>;
}
ChangePasswordModal.propTypes = { onClose: PropTypes.func.isRequired, onChanged: PropTypes.func.isRequired };
